import script from "./collection-operation.vue?vue&type=script&setup=true&lang=js"
export * from "./collection-operation.vue?vue&type=script&setup=true&lang=js"

import "./collection-operation.vue?vue&type=style&index=0&id=22158e62&lang=scss&scoped=true"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22158e62"]])

export default __exports__